import { configureOidc } from "@/store/services/security.service";
import Axios from "axios";
import { OidcAuth } from "vue-oidc-client/vue2";
export default async function () {
    const token = configureOidc().then(
        (auth: OidcAuth) => {
            Axios.defaults.headers.common["Authorization"] =
                "Bearer " + auth.accessToken;
        },
        (err) => {
            console.log(err);
        }
    );
}
